<template>
  <v-navigation-drawer
    v-model="localDrawer"
    color="#2d4f6c"
    dark
    :app="true"
    :temporary="!isDesktop"
    :mini-variant="isDesktop && localMini"
    :clipped="isDesktop"
    @update:mini-variant="emitMini"
    elevation="2"
  >
    <div class="sidebar-wrapper">
      <v-list dense>
        <template v-for="menu in menus">
          <v-list-item 
            v-if="!menu.children || menu.children.length === 0"
            :key="menu.id"
            :to="menu.route"
            @click="closeDrawerIfMobile"
          >
            <v-list-item-icon>
              <v-icon>mdi-{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content v-if="!localMini">
              <v-list-item-title>{{ menu.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else
            :key="menu.id"
            :value="isGroupActive(menu)"
            :prepend-icon="`mdi-${menu.icon}`"
          >
            <template v-slot:activator>
              <v-list-item-content v-if="!localMini">
                <v-list-item-title>{{ menu.name }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="child in menu.children"
              :key="child.id"
              :to="child.route"
              :class="['submenu-item', { 'submenu-item--mini': localMini }]"
              @click="closeDrawerIfMobile"
            >
              <v-list-item-icon>
                <v-icon>mdi-{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content v-if="!localMini">
                <v-list-item-title>{{ child.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
       <div class="sidebar-footer">
        <v-divider class="sidebar-footer-divider"></v-divider>
        <v-list dense class="py-1">
          <v-list-item @click="openLogoutDialog" class="logout-item">
            <v-list-item-icon>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content v-if="!localMini">
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div class="sidebar-copyright" v-if="!localMini">
          &copy; {{ currentYear }} J99Corp &mdash; Satu-KPI
        </div>
      </div>
        <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="text-center" style="background-color:#2d4f6c;">
          <v-row align="center" justify="center">
            <v-col cols="12">
              <h5 style="font-weight:700; color: #fff;">Confirm</h5>
            </v-col>
          </v-row>  
        </v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <h4>Are you sure you want to logout from Satu-KPI?</h4>
              </v-col>
            </v-row> 
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#2d4f6c" style="color: #fff;" @click="logout">Yes</v-btn>
          <v-btn color="#2d4f6c" style="color: #fff;" @click="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  props: ['drawer', 'miniVariant'],
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    localDrawer: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.$emit('update:drawer', val);
      }
    },
    localMini: {
      get() {
        return this.miniVariant;
      }
    },
    currentYear() {
      return new Date().getFullYear();
    },
    menus() {
    const rawMenus = this.$store.getters.getMenus || []
    return rawMenus
        .filter(menu => menu.is_active === 1)
        .map(menu => {
          const newMenu = { ...menu }
          if (newMenu.children && Array.isArray(newMenu.children)) {
            newMenu.children = newMenu.children.filter(child => child.is_active === 1)
          }

          return newMenu
        })
    }
  },
  methods: {
    isGroupActive(menu) {
      if (!menu.children || !Array.isArray(menu.children)) return false
      const currentPath = this.$route.path
      return menu.children.some(child => child.route && currentPath.startsWith(child.route))
    },
    emitMini(val) {
      this.$emit('update:miniVariant', val);
    },
    closeDrawerIfMobile() {
      if (!this.isDesktop) {
        this.$emit('update:drawer', false);
      }
    },
    openLogoutDialog() {
      this.dialog = true
    },
    logout() {
    this.loading = true
    this.$store.dispatch("logoutUser")
      .then(() => {
        this.dialog = false
        this.loading = false
        this.$router.push('/')
      })
      .catch(err => {
        this.dialog = false
        this.loading = false
        alert("Logout gagal. Silakan coba lagi.")
        console.error(err)
      })
    }
  }
}
</script>
<style scoped>

.sidebar-wrapper {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.sidebar-list {
  flex: 1 1 auto;
  overflow-y: auto;
  padding-bottom: 10px;
}

.sidebar-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: inherit;
}
.sidebar-footer-divider {
  border-color: rgba(255, 255, 255, 0.15) !important;
}
.sidebar-copyright {
  text-align: center;
  font-size: 0.6875rem;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.5);
  padding: 8px 12px 12px;
  margin-top: 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.15);
}
.logout-item {
  color: rgba(255, 255, 255, 0.85);
}

.submenu-item {
  margin-left: 1rem;
}

/* Saat mini-variant, indent 1rem di atas mendorong ikon keluar dari lebar
   rail yang sempit sehingga terlihat terpotong — kembalikan ke tengah
   seperti item menu utama. */
.submenu-item--mini {
  margin-left: 0;
}
.submenu-item--mini >>> .v-list-item__icon {
  margin-left: auto;
  margin-right: auto;
}

</style>
